import React, { useEffect, useState } from 'react';
import serverStore from '../../../stores/server.store';
import uptimeStore from '../../../stores/uptime.store';
import Header from '../../components/header/Header';
import LoaderComponent from '../../components/Loader.component';
import uptimeCheckStore from '../../../stores/uptimeChecks.store';
import UptimeItemWrapper from './components/UptimeItem';
import mongoDbStore from '../../../stores/mongodb.store';
import { addToast } from '../../components/toasts/Toast';
import { startPolling } from '../../../servises/polling.service';
import { Redirect } from 'react-router-dom';
import { loadDetailData } from '../../../servises/detail-loading.service';
import MonitorLoadError from './components/MonitorLoadError';

const UptimeItemPage = props => {
    document.title = 'Monitors - SyAgent';
    const { uptimeId } = props.match.params;

    const [loader, setLoader] = useState(true);
    const [loadedUptimeId, setLoadedUptimeId] = useState(null);
    const [uptimeListLoaded, setUptimeListLoaded] = useState(false);
    const [loadError, setLoadError] = useState(false);
    const [loadSequence, setLoadSequence] = useState(0);

    useEffect(() => {
        let active = true;
        setLoader(true);
        setUptimeListLoaded(false);
        setLoadError(false);
        uptimeCheckStore.clear();
        const getServersData = async () => {
            const secondaryFailed = await loadDetailData(
                uptimeStore.getUptime(true),
                [
                    serverStore.getServers(),
                    mongoDbStore.getMongoDb(),
                    uptimeCheckStore.getUptimeChecks(uptimeId)
                ]
            );
            if (secondaryFailed) {
                addToast('Some monitor data could not be loaded', 'error');
            }
            if (active) {
                setUptimeListLoaded(true);
            }
        };
        getServersData()
            .catch(error => {
                addToast(error.message || 'Failed to load monitor', 'error');
                if (active) {
                    setLoadError(true);
                }
            })
            .finally(() => {
                if (active) {
                    setLoadedUptimeId(uptimeId);
                    setLoader(false);
                }
            });
        return () => {
            active = false;
        };
    }, [uptimeId, loadSequence]);

    useEffect(() => {
        return startPolling(() => {
            return Promise.all([
                uptimeCheckStore.getUptimeChecks(uptimeId)
            ]);
        }, 60000, error => {
            addToast(error.message || 'Failed to refresh monitor', 'error', 'monitor-refresh');
        });
    }, [uptimeId]);

    if (loadError) {
        return <MonitorLoadError onRetry={ () => setLoadSequence(value => value + 1) }/>;
    }

    return (
        <main className="servers">
            <Header/>
            { (loader || loadedUptimeId !== uptimeId) && (
                <LoaderComponent/>
            ) }

            { !loader && loadedUptimeId === uptimeId && (
                <>
                    { uptimeListLoaded && !uptimeStore.uptimeListObj[uptimeId] && (
                        <Redirect to="/404"/>
                    ) }
                    { uptimeListLoaded && uptimeStore.uptimeListObj[uptimeId] && (
                        <UptimeItemWrapper uptimeId={ uptimeId }/>
                    ) }
                </>
            ) }
        </main>
    );
};

export default UptimeItemPage;
